import { Game } from '@denishussar/html5-game-engine';
import { GameInstance } from './game/GameInstance';

import * as WebFont from 'webfontloader';

declare var require;
require('../fonts/fonts.css');
const gameCfg = require('../game-config.json');

export class Games {
    public static startGame(elementId?: string): Game {
        return new Game({
            main: GameInstance,
            version: '0.9.5',
            sounds: [
                {
                    id: 'menu',
                    path: '/sounds/menu.mp3',
                },
                {
                    id: 'button_click',
                    path: '/sounds/button_click.mp3',
                },
                {
                    id: 'pause',
                    path: '/sounds/pause.mp3',
                },
                {
                    id: 'game',
                    path: '/sounds/game.mp3',
                },
            ],
            assetsRoot: gameCfg.resourcesRoot,
            elementId: elementId || 'gamePlace',
            noWebGL: false,
            backgroundColor: 0x212b44,
            clearBeforeRender: true,
            transparent: false,
            fps: 60,
            gameId: gameCfg.gameId,
            orientations: [
                // {
                //     orientation:ScreenOrientationEnum.Portrait,
                //     orientationEnvironment: EnvironmentTypeEnum.phone
                // },
                // {
                //     orientation:ScreenOrientationEnum.PortraitAndLandscape,
                //     orientationEnvironment: EnvironmentTypeEnum.pc | EnvironmentTypeEnum.tablet
                // }
            ],
        });
    }
}

WebFont.load({
    custom: {
        families: [
            'Times New Roman',
            'Arial Black',
            'Montserrat',
            'Myriad Pro',
            'MyriadPro-Regular',
            'MyriadPro-Bold',
        ],
    },
    loading: () => Games.startGame(),
});
